import React from "react";
import Card from "react-bootstrap/Card";
import { PERSONAL_INFO, SOCIAL_LINKS } from "../../config/constants";
import { FaLinkedinIn } from "react-icons/fa";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body className="about-content">
        <p className="about-body">
          I'm <span className="about-name">Amit Halfon</span>, a{" "}
          {PERSONAL_INFO.title.toLowerCase()} with{" "}
          a <strong className="about-highlight">B.Sc. in Computer Science</strong>
        </p>

        <p className="about-body">
          I focus on <strong className="about-highlight">backend</strong> and{" "}
          <strong className="about-highlight">distributed systems</strong> using{" "}
          <strong className="about-highlight">Java</strong> and{" "}
          <strong className="about-highlight">Node.js</strong>, with hands-on
          experience in <strong className="about-highlight">Kubernetes</strong>,{" "}
          <strong className="about-highlight">Docker</strong>, and{" "}
          <strong className="about-highlight">AWS</strong>.
        </p>

        <p className="about-body">
          I am an active adopter of{" "}
          <strong className="about-highlight">AI assisted development</strong>,
          leveraging tools like <strong className="about-highlight">Cursor</strong>,{" "}
          <strong className="about-highlight">Claude Code</strong>, and{" "}
          <strong className="about-highlight">GitHub Copilot</strong>.
        </p>

        <p className="about-body">
          Driven by a passion for innovation, I specialize in end to end feature
          development across the entire lifecycle, enjoying complex challenges
          that involve integrating cutting edge technologies.
        </p>

        
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
